export const integrationIcon = `
<svg width="100%" height="100%" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="26" height="26" />
<circle cx="8.64038" cy="12.9211" r="2.64038" stroke="currentColor" stroke-width="2"/>
<circle cx="16.7302" cy="5.64038" r="2.64038" stroke="currentColor" stroke-width="2"/>
<circle cx="16.7302" cy="20.2014" r="2.64038" stroke="currentColor" stroke-width="2"/>
<path d="M10.6626 10.8985L14.7075 7.6626" stroke="currentColor" stroke-width="2"/>
<path d="M10.6626 14.9433L14.7075 18.1792" stroke="currentColor" stroke-width="2"/>
</svg>
`;
